import { fromJS  } from 'immutable';

export const State = fromJS({
  errMsg: '',
  isGetting: false,
  notes: {},
});